angular.module('Itao.IndicatorMap').directive('horizontalBarChart', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;

  var sortedAccessor = function (d, i) {
    return i;
  };
  var combineData = function (layer, indicators, selectedDistricts, disabledDistrictKeys) {
    if (!layer) return [];
    var data = [];
    var selectedUids = selectedDistricts.map(function (district) {
      return district.uid;
    });

    for (var districtUid in layer.districts) {
      if (layer.hasOwnProperty(districtUid) && disabledDistrictKeys.indexOf(layer.districts[districtUid].key) === -1) {
        var valueArray = indicators.map(function (indicator) {
          // '+' for cast to number
          return {value: +layer[districtUid][indicator.uid], key: indicator.key};
        });
        data.push({
          key: layer.districts[districtUid].key,
          name: layer.districts[districtUid].name,
          hasNoGeoData: layer.districts[districtUid].hasNoGeoData,
          values: valueArray,
          selected: selectedUids.indexOf(districtUid) !== -1
        });
      }
    }
    return data;
  };

  var calculateMaxValue = function (data) {
    return d3.max(data.map(function (current) {
      return d3.max(current.values, accessor('value'));
    }));
  };

  var calculateMinValue = function (data) {
    return d3.min(data.map(function (current) {
      return d3.min(current.values, accessor('value'));
    }));
  };

  var horizontalBarChart = function () {
    var indicators = [],
      disabledIndicators = [],
      districtLabelProperty = 'key',
      svgHeight = 200,
      displayValues = false,
      color = d3.hyperion.indicatorColorAt,
      redLines = null,
      margin = {top: 40, right: 40, bottom: 40, left: 50},
      duration = 400,
      decimals,
      maxAxisValue,
      tip;

    var chart = function (selection) {
      selection.each(function (data) {
        var filteredIndicators = indicators.filter(function (indicator) {
          return disabledIndicators.indexOf(indicator.key) === -1;
        });

        //calculate min and max values and check that 0 is included
        var minValue = calculateMinValue(data);
        var maxValue = calculateMaxValue(data);

        if (minValue > 0) {
          minValue = 0;
        }

        if (maxValue < 0) {
          maxValue = 0;
        }

        if (mapConfig.axisMaxValue != null && maxValue < mapConfig.axisMaxValue) {
          maxValue = mapConfig.axisMaxValue;
        }

        var axisFormatString = ',.' + (decimals ? decimals : (maxValue < 7 ? '1' : '0')) + 'f';
        var maxDomainValue = maxAxisValue ? maxAxisValue : maxValue;
        var container = d3.select(this).datum([data]).classed('horizontal-bar-chart', true);
        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars
        var districtLabelDigits = d3.max(data.map(function (d) {
          return accessor(districtLabelProperty)(d).length;
        }));

        margin.left = Math.min(15 + 8 * districtLabelDigits, svgWidth / 2); // use a maximum of half the widget for labels

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if (angular.isDefined(tip)) {
          tip.destroy();
        }

        var colorFromBar = compose(color, function (d, i) {
          return indicators.map(accessor('key')).indexOf(filteredIndicators[i].key);
        });

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function () {
            return [-5, 0];
          })
          .html(function (d, indicatorNumber, districtNumber) {
            var district = data[districtNumber], value;
            if (!decimals) {
              decimals = filteredIndicators[indicatorNumber].unit === '%' ? mapConfig.relativeIndicatorsDecimalPlaces : mapConfig.absoluteIndicatorsDecimalPlaces;
            }

            if (filteredIndicators[indicatorNumber].unit === '%') {
              value = filteredIndicators[indicatorNumber].prefix + germanNumberFormat(',.' + decimals + 'f')(d.value) + '%';
            } else {
              value = filteredIndicators[indicatorNumber].prefix + germanNumberFormat(',.' + decimals + 'f')(d.value);
            }
            return '<div class="d3-tip-border" style="border-color:' + colorFromBar(d, indicatorNumber) + ';"><b>' + district.name + ' (' + district.key + ')</b><br><span>' + filteredIndicators[indicatorNumber].name + ':</span> <span class="tooltip-value">' + value + '</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);

        var svgEnter = svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for districts
        var y0 = d3.scale.ordinal()
          .rangeRoundBands([0, height], 0.3)
          .domain(data.map(accessor(districtLabelProperty)));

        // scale for each bar per district
        var y1 = d3.scale.ordinal()
          .domain(filteredIndicators.length < 2 ? [0] : d3.range(filteredIndicators.length)) // use only active indicators
          .rangeRoundBands([0, y0.rangeBand()]);

        // scale for bar values
        var x = d3.scale.linear()
          .range([0, width])
          .domain([minValue, maxDomainValue])
          .nice();

        var tickCount = Math.min(svgWidth / 90, 10);

        var xAxis = d3.svg.axis()
          .scale(x)
          .ticks(tickCount)
          .tickFormat(function (d) {
            return filteredIndicators[0].prefix + germanNumberFormat(axisFormatString)(d);
          })
          .orient('bottom');

        var yAxis = d3.svg.axis()
          .scale(y0)
          .orient('left');

        g.call(d3.hyperion.addVerticalGridLines(x, height, 0, tickCount, duration));

        gEnter.append('g')
          .attr('class', 'x axis')
          .attr('transform', 'translate(0,' + height + ')');

        g.select('.x.axis')
          .transition().duration(duration)
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis);

        gEnter.append('g')
          .attr('class', 'y axis');

        g.select('.y.axis')
          .call(yAxis)
          .selectAll('text')
          .data(data)
          .style('font-weight', function (d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .style('fill', function (d) {
            return accessor('hasNoGeoData')(d) ? '#aaa' : '#000';
          });

        // only draw bars if indicators are left
        if (angular.isArray(filteredIndicators) && filteredIndicators.length > 0) {

          redLines = redLines ? redLines : mapConfig.redLines.filter(function (lineValue) {
            return lineValue <= maxValue;
          });
          g.call(d3.hyperion.addVerticalHighlightArea(redLines, y0, x, height, duration));
          var unit = filteredIndicators[0].unit;

          svgEnter.append('text')
            .attr('class', 'axis-unit-label')
            .attr('text-anchor', 'left')
            .attr('dominant-baseline', 'text-before-edge');
          // .attr('transform', 'translate(0,'+(height/2)+')rotate(-90)')

          svg.select('.axis-unit-label')
            .text(unit === '%' ? 'in %' : '');

          // create a feature per district
          var features = g.selectAll('.feature')
            .data(data, accessor('key'));

          features
            .enter().append('g')
            .classed('feature', true)
            .attr('transform', function (d) {
              return 'translate(0,' + y0(d[districtLabelProperty]) + ')';
            })
            .attr('stroke', 'black')
            .attr('x', 0);

          features
            .attr('stroke-width', function (d) {
              return accessor('selected')(d) ? '2px' : '0px';
            })
            .transition().duration(duration)
            .attr('transform', function (d) {
              return 'translate(0,' + y0(d[districtLabelProperty]) + ')';
            });

          features.exit().remove();

          var bars = features.selectAll('rect')
            .data(accessor('values'), accessor('key'));

          // draw new bars
          bars
            .enter()
            .append('rect')
            .style('fill', colorFromBar)
            .attr('height', y1.rangeBand())
            .attr('y', compose(y1, sortedAccessor))
            .attr('x', x(0))
            .attr('width', 0);

          // update all bars
          bars
            .transition().duration(duration)
            .style('fill', colorFromBar)
            .attr('height', y1.rangeBand())
            .attr('y', compose(y1, sortedAccessor))
            .attr('x', function (d) {
              return x(Math.min(0, accessor('value')(d)));
            })
            .attr('width', function (d) {
              return Math.abs(x(0) - x(accessor('value')(d)));
            });

          // add tooltips to bars
          bars.call(tip);
          bars.on('mouseover', tip.show)
            .on('mouseout', tip.hide);

          // remove unused bars
          bars.exit().transition().duration(duration)
            .attr('width', 0)
            .attr('height', 0)
            .remove();

          var labels = features.selectAll('text')
            .data(accessor('values'), accessor('key'));

          if (displayValues) {
            // new labels
            labels
              .enter()
              .append('text')
              .attr('x', x(0))
              .attr('stroke-width', '0');

            // update labels
            labels
              .transition().duration(duration)
              .attr("class", "chart-value horizontal")
              .text(function (d) {
                return germanNumberFormat('.' + mapConfig.relativeIndicatorsDecimalPlaces + 'f')(accessor('value')(d));
              })
              .attr('y', function (d, i) {
                return (y1.rangeBand() / 2) + (y1.rangeBand() * i) + 4;
              })
              .attr('x', function (d) {
                return x(Math.max(0, accessor('value')(d))) + 4;
              });

            // remove unused labels
            labels.exit().transition().duration(duration)
              .attr('x', x(0))
              .remove();
          } else {
            labels.transition().duration(duration)
              .attr('x', x(0))
              .remove();
          }

          g.call(d3.hyperion.addVerticalHighlightLines(redLines, x, height, duration));
        } else {
          // remove all bars if no indicators are active
          g.selectAll('rect').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function (newIndicators) {
      if (!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for disabledIndicators
     * @param {int} [newDisabledIndicators] set of disabled indicators
     * @returns {*}
     */
    chart.disabledIndicators = function (newDisabledIndicators) {
      if (!arguments.length) {
        return disabledIndicators;
      } else {
        disabledIndicators = newDisabledIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for districtLabelProperty
     * @param {string} [newDistrictLabelProperty] name of property to use for districtlabels
     * @returns {*}
     */
    chart.districtLabelProperty = function (newDistrictLabelProperty) {
      if (!arguments.length) {
        return districtLabelProperty;
      } else {
        districtLabelProperty = newDistrictLabelProperty;
        return chart;
      }
    };

    /**
     * getter/setter for color
     * @param {Function} [newColor] new color function
     * @returns {*}
     */
    chart.color = function (newColor) {
      if (!arguments.length) {
        return color;
      } else {
        color = newColor;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function (newHeight) {
      if (!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };

    /**
     * getter/setter for redLines
     * @param {Function} [newRedLines] new redLines function
     * @returns {*}
     */
    chart.redLines = function (newRedLines) {
      if (!arguments.length) {
        return redLines;
      } else {
        redLines = newRedLines;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDecimals] height of the diagram
     * @returns {*}
     */
    chart.decimals = function (newDecimals) {
      if (!arguments.length && !decimals) {
        return decimals;
      } else {
        decimals = newDecimals;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {float} [newMaxAxisValue] height of the diagram
     * @returns {*}
     */
    chart.maxAxisValue = function (newMaxAxisValue) {
      if (!arguments.length) {
        return maxAxisValue;
      } else {
        maxAxisValue = newMaxAxisValue;
        return chart;
      }
    };

    /**
     * getter/setter for displayValues
     * @param {int} [newDisplayValues] height of the diagram
     * @returns {*}
     */
    chart.displayValues = function (newDisplayValues) {
      if (!arguments.length) {
        return displayValues;
      } else {
        displayValues = newDisplayValues;
        return chart;
      }
    };

    /**
     *
     * @returns {*}
     */
    chart.tip = function () {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function (element) {
    var content = element.closest('.grid-stack-item-content-horizontalBarChart');

    return content.height() - jQuery(content).find('chart-indicator-legend').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'horizontalBarChart.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      indicators: '=',
      disabledDistrictKeys: '=',
      selectedChartColorset: '=',
      colorsets: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.disabledIndicators = scope.config.disabledIndicators || [];
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.config.fullscreen = scope.config.fullscreen || false;
      scope.config.displayValues = scope.config.displayValues || false;

      var horizontalBarChartFunction = horizontalBarChart();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function (watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if (Object.keys(scope.layer.districts).length === scope.disabledDistrictKeys.length) {
          return null;
        }

        if (newHeight == null) {
          newHeight = calculateChartHeight(element);
        }

        var indicators = scope.indicators.filter(function (indicator) {
          return indicator.hasShapeData;
        });

        var filteredIndicators = indicators.filter(function (indicator) {
          return scope.config.disabledIndicators.indexOf(indicator.key) === -1;
        });

        var color,
          redLines = null,
          legend,
          decimals,
          maxAxisValue;

        if (scope.layer.legend != null) {
          color = d3.hyperion.buildColorFunction(filteredIndicators.map(function (indicator) {
            if (scope.layer.legend[indicator.uid]) {
              var colorsetUid = scope.layer.legend[indicator.uid].chart.colorSet;
              var indicatorColorSet = scope.colorsets.filter(function (colorSet) {
                return colorSet.uid === colorsetUid;
              })[0];

              legend = scope.layer.legend[indicator.uid];
              if (legend.chart && legend.chart.decimals !== null) {
                decimals = legend.chart.decimals;
              }

              if (legend.chart && legend.chart.maxAxisValue) {
                maxAxisValue = legend.chart.maxAxisValue;
              }

              if (legend.chart && legend.chart.redLines) {
                redLines = legend.chart.redLines;
              }

              var indicatorColor = '';
              if (indicatorColorSet != null) {
                indicatorColor = indicatorColorSet.colors[0].color;
              }
              return indicatorColor;
            } else {
              return d3.hyperion.indicatorColorAt;
            }
          }));
        } else if (scope.selectedChartColorset) {
          color = d3.hyperion.buildColorFunction(scope.selectedChartColorset.colors.map(function (color) {
            return color.color;
          }));
        } else {
          color = d3.hyperion.indicatorColorAt;
        }

        var data = combineData(scope.layer, filteredIndicators, scope.selectedDistricts, scope.disabledDistrictKeys);
        horizontalBarChartFunction
          .color(color)
          .redLines(redLines)
          .indicators(indicators)
          .districtLabelProperty(scope.config.districtLabelProperty)
          .disabledIndicators(scope.config.disabledIndicators)
          .displayValues(scope.config.displayValues)
          .decimals(decimals)
          .maxAxisValue(maxAxisValue)
          .height(newHeight);

        d3.select(element.find('.widget-inner:first')[0])
          .data([data])
          .call(horizontalBarChartFunction);
      };

      jQuery(document).on("fullscreen", rerender);
      var layerWatcher = scope.$watchCollection('layer', rerender, true);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var disabledIndicators = scope.$watchCollection('config.disabledIndicators', rerender);
      var districtLabelPropertyWatcher = scope.$watchCollection('config.districtLabelProperty', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);
      var colorsetsWatcher = scope.$watchCollection('colorsets', rerender);
      var disabledDistrictKeysWatcher = scope.$watchCollection('disabledDistrictKeys', rerender);
      var fullscreenWatcher = scope.$watch('config.fullscreen', rerender);
      var displayValuesWatcher = scope.$watch('config.displayValues', rerender);

      var legendHeightWatcher = scope.$watch(function () {
        return calculateChartHeight(element);
      }, function (newValue, oldValue) {
        if (newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });

      // remove watcher on destroy
      element.on('$destroy', function () {
        layerWatcher();
        indicatorWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        disabledIndicators();
        districtLabelPropertyWatcher();
        selectedDistrictsWatcher();
        fullscreenWatcher();
        colorsetsWatcher();
        disabledDistrictKeysWatcher();
        displayValuesWatcher();

        // remove tooltip dom element
        if (angular.isDefined(horizontalBarChartFunction.tip())) {
          horizontalBarChartFunction.tip().destroy();
        }
      });
    }
  };
});
